<template>
  <div class="module_course page_content observation_report learner_observation_report" aria-label="Learner Observation Report Page">
    <div class="row page_content_container">
      <div class="loader_container" v-if="!showPage">
        <stretch class="loader_v24"></stretch>
      </div>
      <div class="col-12 dasboard-left-section report-Page" v-if="showPage">

          <b-row>
            <b-col cols="12">
              <!-- Heading -->
              <b-row class="heading">
                <div class="col-7 hd_txt">
                  <span class="ace_sec_hd">Reports :: </span>
                  <span>{{reportName}}</span>
                </div>

                <div class="col-5 hd_btn_container">
                </div>

              </b-row>

              <!-- Report -->
              <div class="row">
                <div class="col-12 competency-details-row">
                  <table class="table" border="1">
                    <thead>
                      <tr>
                        <th v-for="(col, index) in columns">{{col.label}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in itemsToShow">
                        <td v-for="col in itemsMap[item.key]" :class="col.type">
                          <div class="ic_usr" v-if="col.id === 'name'" :style="{background: setThumbnailBgColor(col.colEntityId)}">
                            <span class="ic22-student1"></span>
                          </div>
                          <div class="ic_usr ic_supervisor" v-if="col.id === 'supervisor'" :style="{background: setThumbnailBgColor(col.instId)}">
                            <div class="bg_layer">
                              <span class="ic22-user-tie"></span>
                            </div>
                          </div>
                          <div :class="col.cssClass" v-if="col.type !== 'deadline'"> {{col.label}}</div>
                          <div :class="col.cssClass" style="padding: 5px" v-if="col.type === 'deadline'">
                            <div v-if="col.type === 'deadline'" class="row kc_container">
                              <div v-for="kc in kCStatusMap[col.userId+'_'+col.courseId+'_'+col.competencyId]" class="col kc_blc" :class="kc.cssClass">
                                &nbsp;
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
          </b-row>

      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/module/sass/reports/classReport.scss'
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import _ from 'lodash'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'learnerObservationReport',
  props: ['uuid', 'courseIds'],
  components: {
    CourseNav,
    CourseHeader,
    Stretch
  },

  data: () => {
    return {
      showPage: false,
      sort: 'sortA',
      selectedCourseIds: [],
      columns: [
        {
          id: 'section',
          label: 'Section'
        },
        {
          id: 'duration',
          label: 'Duration'
        },
        {
          id: 'startDate',
          label: 'Start Date'
        }

      ],
      userMap: {},
      itemsMap: {},
      itemsArray: [],
      observationsResponse: {},
      isAllSections: false,
      searchQuery: '',
      showObservation: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      competencyIds: {},
      kCStatusMap: {},
      courseInfoMap: {}
    }
  },

  watch: {
    sort (newSort) {
      this.itemsArray = this.sortArrayOfObjects(this.itemsArray, 'name', this.sort)
    }
  },

  mounted () {
    this.setupMasterObservationReport()
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadChildrenCompetencySummaryForLearner',
      'loadObservationForLearner',
      'exportObservationoToCsv',
    ]),
    async setupMasterObservationReport () {

      if (this.uuid) {
        // load the current course
        await this.loadCourseDetailFromServer(this.uuid)
      } else {
        // TODO: All Sections Scenario
        this.isAllSections =  true

        // TODO: Might have to setup CourseIds by getting all courses this user has access to.
      }

      let instructorName = ''
      if (this.course.instructorNames.length > 0) {
        instructorName = this.course.instructorNames[0]
      }

      let courseInfoObj = {
        courseId: this.uuid,
        instructorName: instructorName,
        duration: this.course.duration
      }
      this.courseInfoMap[this.uuid] = courseInfoObj

      // if courseIds is empty, then push current course to the selectedCourseIds
      if (typeof this.courseIds !== 'undefined' && this.courseIds.length > 0) {
        this.selectedCourseIds.push(this.courseIds)
      } else {
        this.selectedCourseIds.push(this.uuid)
      }

      // Call ObservationForClass api
      this.observationsResponse = await this.loadObservationForLearner({courseId: this.selectedCourseIds.join(', ')})

      // Set up User map with the observation API response
      this.observationsResponse.forEach((item, i) => {
        if (!(item.userId in this.userMap)) {
          this.userMap[item.userId] = []
        }
        this.userMap[item.userId].push(item)

        if (this.columns.filter(e => e.id === item.competencyId).length === 0) {
          if (item.competencyType !== 'PLO') {
            this.columns.push({ id: item.competencyId, label:item.titleForStudent})
          }
        }
      })

      // Process items
      for (let [key, value] of Object.entries(this.userMap)) {
        // Value is competency obj
        value.forEach((item, i) => {
          if (item.competencyType === 'PLO') {
            let itemsMapKey = key + '_' + item.competencyId
            if (!(itemsMapKey in this.itemsMap)) {

              let supervisorNameObj = {
                id: 'supervisor',
                label: this.courseInfoMap[item.courseId].instructorName,
                type: 'string',
                cssClass: 'usr_name',
                instId: this.courseInfoMap[item.courseId].courseId
              }

              let sectionObj = {
                id: 'section',
                label: item.titleForStudent,
                type: 'string',
                cssClass: 'section'
              }

              let durationObj = {
                id: 'duration',
                label: this.courseInfoMap[item.courseId].duration,
                type: 'string',
                cssClass: 'duration'
              }

              let startDateObj = {
                id: 'startDate',
                label: this.getFormattedDateTime(item.courseStartTime, true),
                type: 'date',
                cssClass: ''
              }

              this.itemsMap[itemsMapKey] = []

              this.itemsMap[itemsMapKey].push(supervisorNameObj)

              this.itemsMap[itemsMapKey].push(sectionObj)
              this.itemsMap[itemsMapKey].push(durationObj)
              this.itemsMap[itemsMapKey].push(startDateObj)

              let itemsArrayObj = {
                name: item.firstName + ' ' + item.lastName,
                key: itemsMapKey
              }
              this.itemsArray.push(itemsArrayObj)
            }
          } else if (item.competencyType === 'CLO') {

              let deadlineObj = {
                id: item.uuid,
                label: this.getFormattedDateTime(item.deadLineTime, true),
                type: 'deadline',
                cssClass: this.computeCSSClassBasedOnDeadline(item.deadLineTime, item.status),
                competencyId: item.competencyId,
                userId: item.userId,
                courseId: item.courseId
              }


              this.competencyIds[item.courseId+'_'+item.competencyId] = {
                competencyId: item.competencyId,
                courseId: item.courseId
              }

              let itemsMapKey = key + '_' + item.parentCompetencyId
              if (itemsMapKey in this.itemsMap) {
                this.itemsMap[itemsMapKey].push(deadlineObj)
              }
          }
        })
      }

      // Process KC status
      for (let [key, value] of Object.entries(this.competencyIds)) {
        let childrenComptencySummaryResponse = await this.loadChildrenCompetencySummaryForLearner({courseId: value.courseId, competencyId: value.competencyId})
        childrenComptencySummaryResponse.forEach((item, i) => {
          if (item.competencyType !== 'CLO') {
            let key = item.userId + '_' + value.courseId + '_' + item.parentCompetencyId

            if (! (key in this.kCStatusMap)) {
              this.kCStatusMap[key] = []
            }
            let kcStatusObj = {
              name: 'KC' + item.order,
              userId: item.userId,
              parentCompetencyId: item.parentCompetencyId,
              status: item.status,
              cssClass: this.getCSSClassNameForCompletion(item.status)
            }
            this.kCStatusMap[key].push(kcStatusObj)
          }
        })

      }

      this.columns.splice(0, 0, {
        id: 'supervisor',
        label: 'Supervisor Name'
      })


      this.showPage = true

    },
    getCSSClassNameForCompletion (status) {
      if (status === 0) {
        return 'deadline_missed'
      }
      if (status === 1 || status > 1) {
        return 'deadline_completed'
      }
    },
    setThumbnailBgColor (uuid) {
      let numValue = uuid.replace(/[^0-9]/g, '')
      return '#' + numValue.slice((numValue.length - 9), (numValue.length - 3))
    },
    getFormattedDateTime (timeInMillis, showOnlyDate) {
      if (timeInMillis === 0) {
        return 'N/A'
      }
      var d
      var str = ''
      d = new Date(timeInMillis)
      str += String(this.months[d.getMonth()])
      str += ' ' + d.getDate()
      str += ', ' + d.getFullYear()
      if (!showOnlyDate) {
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        var currSec = d.getSeconds()
        currSec = currSec + ''
        if (currSec.length === 1) {
          currSec = '0' + currSec
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ':' + currSec
        str += ' ' + amPm
      }
      return str
    },
    computeCSSClassBasedOnDeadline (deadline, status) {
      if (status === 2) {
        return 'deadline_completed'
      }
      return 'deadline_missed'
    },
    isTwoWeekMinum (deadLineTime) {
      var today = new Date()
      var currentPlus2Week = today.getTime() + 2*7*(60 * 24) * 60 * 1000
      // 0-2Weeks
      return (deadLineTime > today.getTime() && deadLineTime < currentPlus2Week )
    },
    isTwoWeekPlus (deadLineTime) {
      var today = new Date()
      var currentPlus2Week = today.getTime() + 2*7*(60 * 24) * 60 * 1000
      var currentPlus4Week = today.getTime() + 4*7*(60 * 24) * 60 * 1000
      // >2weeks
      return  (deadLineTime > currentPlus2Week && deadLineTime < currentPlus4Week)
    },
    isPassed (deadLineTime) {
      var today = new Date()
      return (deadLineTime >0 && deadLineTime < today.getTime())
    },
    isFourWeekPlus (deadLineTime) {
      var today = new Date()
      var currentPlus4Week = today.getTime() + 4*7*(60 * 24) * 60 * 1000
      return (deadLineTime > currentPlus4Week || deadLineTime === 0)
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    sortArrayOfObjects (arr, propertyName, order) {

      if (order === 'sortA') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] < b[propertyName]) {
            return -1
          }
          if (a[propertyName] > b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

      if (order === 'sortD') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] > b[propertyName]) {
            return -1
          }
          if (a[propertyName] < b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'fullClassSummary': state => state.course.fullClassSummary,
      'competencySummaryForClass': state => state.course.competencySummaryForClass,
      'childrenCompetencySummaryForClass': state => state.course.childrenCompetencySummaryForClass,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'userObj': state => state.user.userObj
    }),
    reportName () {
      if (this.isAllSections) {
        return 'All Sections'
      } else if (this.course) {
        return this.course.title
      }
    },
    itemsToShow () {
      return this.itemsArray.filter(item => {
        return item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      })
    }
  }

}
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/app/course/components/LearnerObservationReport.vue